export default __webpack_public_path__ + "static/media/402A87621E2366C4.6239575a.png";